"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconContainer = exports.StyledBadgeAnchor = exports.StyledBadgeContent = exports.StyledBadge = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const Icon_styles_1 = require("../Icon/Icon.styles");
const Text_styles_1 = require("../Text/Text.styles");
const getBorderRadius = (radius) => {
    switch (radius) {
        case "full":
            return "100px";
        default:
            return tokens_1.BORDERS.radius;
    }
};
const getBorderStyling = (theme, colour, luminosity) => {
    if (theme === "ghost") {
        const isHighLum = luminosity === "high";
        if (colour === "greyscale")
            return isHighLum ? tokens_1.BORDERS.soft.stone : tokens_1.BORDERS.normal.night;
        if (tokens_1.BORDERS.soft[colour] && isHighLum)
            return tokens_1.BORDERS.soft[colour];
        if (tokens_1.BORDERS.normal[colour] && !isHighLum)
            return tokens_1.BORDERS.normal[colour];
    }
    return tokens_1.BORDERS.normal.transparent;
};
const getBgColour = (theme, colour, luminosity) => {
    if (theme === "solid") {
        const isHighLum = luminosity === "high";
        if (colour === "greyscale")
            return isHighLum
                ? tokens_1.COLOURS.greyscale.silver
                : tokens_1.COLOURS.greyscale.zinc;
        if (tokens_1.COLOURS.primary[colour])
            return isHighLum
                ? tokens_1.COLOURS.primary[colour][25]
                : tokens_1.COLOURS.primary[colour][100];
    }
    return tokens_1.COLOURS.transparent;
};
const getTextOrSvgColour = (theme, colour, luminosity) => {
    const isHighLum = luminosity === "high";
    if (theme === "solid") {
        return isHighLum ? tokens_1.COLOURS.greyscale.night : tokens_1.COLOURS.greyscale.white;
    }
    const lowLumColourShade = theme === "ghost" ? 130 : 100;
    const highLumColourShade = theme === "ghost" ? 50 : 25;
    if (colour === "greyscale")
        return isHighLum ? tokens_1.COLOURS.greyscale.stone : tokens_1.COLOURS.greyscale.night;
    if (tokens_1.COLOURS.primary[colour])
        return isHighLum
            ? tokens_1.COLOURS.primary[colour][highLumColourShade]
            : tokens_1.COLOURS.primary[colour][lowLumColourShade];
    /** Fallback */
    return tokens_1.COLOURS.greyscale.night;
};
const getBadgePadding = (contentType, size) => {
    const isLarge = size === "large";
    switch (contentType) {
        case "icon":
            if (isLarge)
                return `${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[1]}`;
            return `${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[0.5]}`;
        case "textWithIcon":
        case "text":
            if (isLarge)
                return `${tokens_1.SIZES[0.25]} ${tokens_1.SIZES[1]}`;
            return `0 ${tokens_1.SIZES[0.5]}`;
        case "empty":
        default:
            if (isLarge)
                return `${tokens_1.SIZES[1.5]}`;
            return `${tokens_1.SIZES[1]}`;
    }
};
exports.StyledBadge = styled_components_1.default.span `
    position: relative;
    display: inline-block;

    padding: ${({ contentType, size }) => getBadgePadding(contentType, size)};
    border-radius: ${({ radius }) => getBorderRadius(radius)};
    background-color: ${({ theme, colour, luminosity }) => getBgColour(theme, colour, luminosity)};

    ${({ isClickable }) => isClickable ? "cursor: pointer;" : ""}

    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: ${({ theme, colour, luminosity }) => getBorderStyling(theme, colour, luminosity)};
        border-radius: ${({ radius }) => getBorderRadius(radius)};
    }

    ${Text_styles_1.StyledText} {
        color: ${({ theme, colour, luminosity }) => getTextOrSvgColour(theme, colour, luminosity)};
    }

    ${Icon_styles_1.StyledIcon} path {
        fill: ${({ theme, colour, luminosity }) => getTextOrSvgColour(theme, colour, luminosity)};
    }
`;
exports.StyledBadgeContent = styled_components_1.default.span `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${tokens_1.SIZES[0.5]};
    ${({ size }) => size === "medium" ? `padding: 0 ${tokens_1.SIZES[0.25]};` : ""}
`;
exports.StyledBadgeAnchor = styled_components_1.default.div `
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${exports.StyledBadge} {
        position: absolute;
        top: ${tokens_1.SIZES[0.5]};
        right: ${tokens_1.SIZES[0.5]};
        z-index: 1;
        transform: translate(50%, -50%);
        transform-origin: center;
    }
`;
exports.StyledIconContainer = styled_components_1.default.span `
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
//# sourceMappingURL=Badge.styles.js.map